import React from 'react';
import { Link } from 'react-router-dom';

import resume from '../../assets/files/resume.pdf';
import logo from '../../assets/logo.png';

import './Header.css';

const Header = () => {
    return (
        <div className='header-container'>
            <div className='header-content'>
                <Link to='/'>
                    <img className='logo' alt='logo' src={logo} />
                </Link>

                <ul className='navigation'>
                    <li><Link to='/projects'>Projects</Link></li>
                    <li><a href={resume} target='_blank' rel='noreferrer'>Resume</a></li>
                    <li><a href='https://caofontaine.blogspot.com' target='_blank' rel='noreferrer'>Blog</a></li>
                </ul>
            </div>
        </div>
    )
}

export default Header;